/* NERDIS · la forma con la que se enseña el calcetín.
 *
 * DOS COSAS QUE NO SON OBVIAS Y QUE LO EXPLICAN TODO:
 *
 * 1. De un calcetín puesto SOLO SE VE LA MITAD DEL CONTORNO. La lámina son
 *    257,7 mm de contorno completo; de frente se ven 128,85, que son las DOS
 *    SECCIONES CENTRALES -de 64,4 a 193,3-. Por eso un calcetín se ve LARGO Y
 *    ESTRECHO (1:3,76) y no con la proporción de la lámina (1:1,88).
 *
 * 2. Esa cara frontal se mapea sobre la CAÑA, no sobre toda la caja: dibujando
 *    la lámina a caja completa se recortaba un 10% por cada lado.
 *
 * LA SILUETA ES RECTA. Sin bulto de talón: un calcetín en plano es un tubo con
 * la puntera redondeada, y cualquier curva de más canta a dibujo.
 *
 * La PUNTERA NEGRA es del calcetín, no del estampado: viene tejida. Por eso se
 * pinta aquí y no en la lámina - el archivo sigue yendo a sangre.
 *
 * NITIDEZ - por qué encajar() existe (31/08/2026)
 * El canvas tenía el respaldo clavado en 1000x1250 por atributo HTML. En una
 * pantalla normal sobraba, pero en una retina (dpr 2) el navegador tenía que
 * estirar 1000 px sobre 988 px de dispositivo: justo al límite, y agrandar el
 * visor lo habría metido en interpolación. Medido: 0,71x de respaldo por píxel
 * con un visor de 700. Ahora el respaldo se calcula de la caja REAL por
 * devicePixelRatio, así que el visor puede crecer sin perder filo. Medido
 * después: 1,49x de origen por píxel a dpr 1, 2 y 3.
 *
 * Y la proporción del lienzo ya no es fija. Con 1:1,25 clavado, una caja alta
 * -la de escritorio- dejaba un 30% del ancho vacío y el calcetín salía más
 * pequeño de lo que cabía. Ahora el lienzo adopta la proporción de su caja.
 */
(function () {
  'use strict';
  window.NERDIS = window.NERDIS || {};

  var FRENTE_DESDE = 0.25, FRENTE_ANCHO = 0.50;   // las dos secciones centrales
  var CANA_DESDE = 0.06, CANA_ANCHO = 0.88;
  /* 459 de 485: la puntera de la tabla de zonas del Lab
     (puño 0-20, caña 20-220, tobillo 220-250, talón 250-280, pie 280-459,
     puntera 459-485). Con 0,925 el negro empezaba en 448 y se comía el
     wordmark, que va justo a 448. */
  var PUNTERA = 459 / 485;
  var NEGRO = '#1D1D1F';

  var LAMINA_REL = 485 / 257.7;     // alto/ancho de la lámina entera
  var CARA_MM = 128.85;             // lo que se ve de frente, en milímetros
  var DPR_TOPE = 3;                 // de 3 para arriba no se gana nada visible
  var PROP_MIN = 1.0, PROP_MAX = 1.9;

  /* Recto y con la puntera redondeada. Nada más. */
  function ruta(g, x, y, w, h) {
    var X = function (t) { return x + t * w; }, Y = function (t) { return y + t * h; };
    var r = 0.070;
    g.beginPath();
    g.moveTo(X(0.06), Y(0.000));
    g.lineTo(X(0.06), Y(1 - r));
    g.quadraticCurveTo(X(0.06), Y(1.000), X(0.50), Y(1.000));
    g.quadraticCurveTo(X(0.94), Y(1.000), X(0.94), Y(1 - r));
    g.lineTo(X(0.94), Y(0.000));
    g.closePath();
  }

  function uno(g, lam, x, y, w, h, giro, sinSombra) {
    var sx = lam.width * FRENTE_DESDE, sw = lam.width * FRENTE_ANCHO;
    var dx = x + w * CANA_DESDE, dw = w * CANA_ANCHO;

    g.save();
    g.translate(x + w / 2, y + h / 2);
    if (giro) { g.rotate(giro * Math.PI / 180); }
    g.translate(-(x + w / 2), -(y + h / 2));

    /* La sombra es OPCIONAL desde el 8 sep 2026. En el visor da presencia y se
       queda; en la miniatura de la cesta, a 100 px, no se lee como volumen sino
       como suciedad alrededor del calcetin, y ademas se salia del lienzo y
       recortaba el par por los lados. */
    g.save();
    if (!sinSombra) {
      g.shadowColor = 'rgba(0,0,0,.22)';
      g.shadowBlur = w * 0.16;
      g.shadowOffsetY = h * 0.008;
    }
    ruta(g, x, y, w, h);
    g.fillStyle = NEGRO;
    g.fill();
    g.restore();

    ruta(g, x, y, w, h);
    g.save();
    g.clip();

    g.drawImage(lam, sx, 0, sw, lam.height, dx, y, dw, h);

    g.fillStyle = NEGRO;                                   // puntera tejida
    g.fillRect(x, y + h * PUNTERA, w, h * (1 - PUNTERA) + 2);

    var lat = g.createLinearGradient(x, 0, x + w, 0);
    lat.addColorStop(0.00, 'rgba(0,0,0,.32)');
    lat.addColorStop(0.20, 'rgba(0,0,0,0)');
    lat.addColorStop(0.80, 'rgba(0,0,0,0)');
    lat.addColorStop(1.00, 'rgba(0,0,0,.32)');
    g.fillStyle = lat;
    g.fillRect(x, y, w, h);

    g.restore();
    g.restore();
  }

  /* Cuánto mide el calcetín dentro de este lienzo. Está aquí y no repartido
     por par() porque escalaNecesaria() necesita EXACTAMENTE el mismo número:
     si se separan, el preview pide una resolución y dibuja otra. */
  function geometria(cv, forma) {
    var W = cv.width, H = cv.height;
    var rel = LAMINA_REL / FRENTE_ANCHO * CANA_ANCHO;   // alto/ancho del calcetín
    /* Estos números NO son el hueco que se ve: son el rectángulo del calcetín,
       y la tinta se sale de él. La sombra (blur 0,16w) y el giro de 5 grados
       añaden un 8,6% de alto. Medido con 0,90: el dibujo ocupaba de 11 a 717
       en un lienzo de 722 -cuatro píxeles de margen abajo-, o sea al borde de
       recortarse en cuanto la caja cambiase un poco. Con 0,865 la tinta se
       queda en el 94% y sobran ~20 px por lado. */
    var alto = (forma === 'par') ? 0.865 : 0.885;
    var span = (forma === 'uno') ? 1.00 : (forma === 'rectos' ? 2.12 : 1.92);
    var h = H * alto, w = h / rel;
    // en una caja ancha manda el alto; en una estrecha, el ancho
    if (w * span > W * 0.96) { w = W * 0.96 / span; h = w * rel; }
    return { W: W, H: H, w: w, h: h, arte: w * CANA_ANCHO };
  }

  /* Píxeles de origen que necesita la lámina para que el navegador NO tenga
     que inventar ninguno al pintarla. El 1,4 es el margen del remuestreo: con
     1,0 justo, cualquier redondeo ya interpola. */
  function escalaNecesaria(cv, forma) {
    var necesita = geometria(cv, forma || 'par').arte / CARA_MM * 1.4;
    return Math.max(3, Math.min(7, Math.ceil(necesita)));
  }

  /* El respaldo del canvas, en píxeles de DISPOSITIVO; y la caja CSS, en
     píxeles de página. Son dos cosas distintas y confundirlas es lo que
     emborrona un canvas en una pantalla retina. */
  function encajar(cv) {
    var caja = cv.parentNode;
    if (!caja) { return false; }
    var s = getComputedStyle(caja);
    var w = caja.clientWidth - parseFloat(s.paddingLeft) - parseFloat(s.paddingRight);
    var h = caja.clientHeight - parseFloat(s.paddingTop) - parseFloat(s.paddingBottom);
    if (!(w > 0 && h > 0)) { return false; }

    var p = Math.max(PROP_MIN, Math.min(PROP_MAX, h / w));
    var cw = Math.min(w, h / p), ch = cw * p;

    // Solo se escribe si cambia: tocar el estilo obliga al navegador a
    // recalcular la página, y esto se llama en cada tecla.
    // La comparación va NEGADA a propósito. La primera vez cv.style.width es
    // '' y parseFloat('') es NaN; con `> 0.5` el NaN da falso y la caja no se
    // escribía nunca. Con `!(<= 0.5)` el NaN entra, que es lo que hace falta.
    // Y SE COMPARAN LAS DOS MEDIDAS, no solo el ancho. Comparando solo el
    // ancho, si la caja cambia de ALTO sin cambiar de ancho, la condicion daba
    // falso y no se reescribia el estilo... pero el respaldo de abajo si se
    // rehacia, porque ese compara W y H. Estilo y respaldo se separaban y el
    // calcetin salia aplastado. No se veia porque al redimensionar la ventana
    // cambian los dos a la vez; salta con «Ver grande», donde el visor pasa a
    // pantalla completa y el ancho se queda igual.
    var actualW = parseFloat(cv.style.width), actualH = parseFloat(cv.style.height);
    if (!(Math.abs(actualW - cw) <= 0.5 && Math.abs(actualH - ch) <= 0.5)) {
      cv.style.width = cw + 'px';
      cv.style.height = ch + 'px';
    }
    var dpr = Math.min(window.devicePixelRatio || 1, DPR_TOPE);
    var W = Math.round(cw * dpr), H = Math.round(ch * dpr);
    if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
    return true;
  }

  function par(cv, lam, opc) {
    opc = opc || {};
    if (!encajar(cv)) { return; }
    dibujar(cv, lam, opc.forma || 'par');
  }

  /* Pinta la forma en UN LIENZO CUALQUIERA, del tamano que ya tenga. Es lo
     que hace par() despues de encajar la caja, separado para poder dibujar
     el par fuera de pantalla: la miniatura de la cesta (4 sep 2026, Carlos:
     "que se identifique un par de calcetines"). */
  function dibujar(cv, lam, forma, opc) {
    forma = forma || 'par';
    var sinSombra = !!(opc && opc.sombra === false);
    var G = geometria(cv, forma);
    var W = G.W, H = G.H, w = G.w, h = G.h, y = (H - h) / 2;
    var g = cv.getContext('2d');
    g.clearRect(0, 0, W, H);
    g.imageSmoothingQuality = 'high';

    if (forma === 'uno') {
      uno(g, lam, (W - w) / 2, y, w, h, 0, sinSombra);
      return;
    }
    if (forma === 'rectos') {
      uno(g, lam, W / 2 - w * 1.06, y, w, h, 0, sinSombra);
      uno(g, lam, W / 2 + w * 0.06, y, w, h, 0, sinSombra);
      return;
    }
    /* El de detrás va 3,5% más abajo, así que lo que hay que centrar es EL PAR
       -h*1,035-, no un calcetín suelto. Centrando cada uno por su cuenta el
       grupo quedaba 31 px de aire arriba y 4,7 abajo: el par parecía escurrido
       y casi tocaba el borde. */
    var yg = (H - h * 1.035) / 2;
    uno(g, lam, W / 2 - w * 0.04, yg + h * 0.035, w, h,  5, sinSombra);   // el de detrás
    uno(g, lam, W / 2 - w * 0.96, yg,             w, h, -4, sinSombra);   // el de delante
  }

  window.NERDIS.forma = {
    par: par, dibujar: dibujar, uno: uno, ruta: ruta,
    encajar: encajar, geometria: geometria, escalaNecesaria: escalaNecesaria
  };
})();
